import { browserTranslator } from "./browserTranslator";
import { googleTranslator } from "./googleTranslator";
import { AUTO_DETECT } from "./languages";

// Tried in order; the first provider that can run and returns text wins.
// Adding the paid service later means appending it here, nothing in the UI.
export const TRANSLATE_PROVIDERS = [browserTranslator, googleTranslator];

export { TRANSLATE_LANGUAGES, POPULAR_LANGUAGES, AUTO_DETECT, getLanguageLabel } from "./languages";

// Long text is chunked by the provider, but a whole book would still hang the tab.
export const TRANSLATE_MAX_TEXT_LENGTH = 50000;

export const translateText = async ({ text, targetLanguage, sourceLanguage = AUTO_DETECT, onStatus }) => {
    const trimmedText = (text || "").trim();

    if (!trimmedText) throw new Error("There is nothing to translate");
    if (!targetLanguage) throw new Error("Please choose a language to translate into");
    if (trimmedText.length > TRANSLATE_MAX_TEXT_LENGTH) {
        throw new Error(`Text must be ${TRANSLATE_MAX_TEXT_LENGTH} characters or less`);
    }

    const failures = [];

    for (const provider of TRANSLATE_PROVIDERS) {
        try {
            const canRun = await provider.isAvailable({ text: trimmedText, sourceLanguage, targetLanguage });
            if (!canRun) {
                failures.push(`${provider.label}: not available in this browser`);
                continue;
            }

            const result = await provider.translate({ text: trimmedText, sourceLanguage, targetLanguage, onStatus });

            if (result?.text?.trim()) {
                return {
                    text: result.text,
                    detectedLanguage: result.detectedLanguage || null,
                    provider: provider.id,
                    providerLabel: provider.label,
                };
            }

            failures.push(`${provider.label}: returned nothing`);
        } catch (error) {
            failures.push(`${provider.label}: ${error?.message || "failed"}`);
        }
    }

    // Kept in the console so a failing provider can be told apart from a failing chain.
    console.warn("Translation providers failed:", failures);
    throw new Error("We couldn't translate this text right now. Please try again.");
};
